<template>
  <v-tooltip 
    :left="left" 
    :right="right" 
    :top="top" 
    :bottom="bottom" 
    color="accent" 
    content-class="caption" 
    :close-delay="tooltips.closeDelay"
    :open-on-hover="true"
    :transition="tooltips.transition">
    <template v-slot:activator="{ on }">
      <span v-on="on">
        <chip-count 
          :color-name="colorName"
          :count="count"
          :postFix="postFix"
        />
      </span>
    </template>
    <span>{{tooltip}}</span>
  </v-tooltip>
</template>
<script>
import Chipcount from '@/components/Chipcount'
import { settings } from '@/js/store'
export default {
  components: {
    'chip-count': Chipcount
  },
  props: {
    count: Number,
    colorName: String,
    tooltip: String,
    right: Boolean,
    left: Boolean,
    top: Boolean,
    bottom: Boolean,
    postFix: String
  },
  computed: {
    tooltips () {
      return settings.tooltips
    }
  }
}
</script>